var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _vm.surveyWindow.isShowing
    ? _c(
        "div",
        {
          class: _vm.surveyWindow.cssRoot,
          style: {
            maxWidth: _vm.surveyWindow.renderedWidth,
            width: _vm.surveyWindow.renderedWidth,
          },
          on: { scroll: _vm.doScroll },
        },
        [
          _c("div", { class: _vm.surveyWindow.cssRootContent }, [
            _c("div", { class: _vm.cssHeaderRoot }, [
              _vm.surveyWindow.isCollapsed && !!_vm.surveyWindow.locTitle
                ? _c(
                    "div",
                    { class: _vm.surveyWindow.cssHeaderTitleCollapsed },
                    [
                      _vm._v(
                        "\n        " +
                          _vm._s(_vm.surveyWindow.locTitle.renderedHtml) +
                          "\n      "
                      ),
                    ]
                  )
                : _vm._e(),
              _vm._v(" "),
              _c("div", { class: _vm.surveyWindow.cssHeaderButtonsContainer }, [
                _vm.surveyWindow.allowFullScreen
                  ? _c(
                      "div",
                      {
                        class: _vm.surveyWindow.cssHeaderFullScreenButton,
                        on: { click: _vm.doToggleFullScreen },
                      },
                      [
                        _vm.surveyWindow.isFullScreen
                          ? _c("sv-svg-icon", {
                              attrs: {
                                iconName: "icon-back-to-panel_16x16",
                                size: 16,
                              },
                            })
                          : _vm._e(),
                        _vm._v(" "),
                        !_vm.surveyWindow.isFullScreen
                          ? _c("sv-svg-icon", {
                              attrs: {
                                iconName: "icon-full-screen_16x16",
                                size: 16,
                              },
                            })
                          : _vm._e(),
                      ],
                      1
                    )
                  : _vm._e(),
                _vm._v(" "),
                _c(
                  "div",
                  {
                    class: _vm.surveyWindow.cssHeaderCollapseButton,
                    on: { click: _vm.doExpand },
                  },
                  [
                    _vm.surveyWindow.isExpanded
                      ? _c("sv-svg-icon", {
                          attrs: { iconName: "icon-minimize_16x16", size: 16 },
                        })
                      : _vm._e(),
                    _vm._v(" "),
                    _vm.surveyWindow.isCollapsed
                      ? _c("sv-svg-icon", {
                          attrs: { iconName: "icon-restore_16x16", size: 16 },
                        })
                      : _vm._e(),
                  ],
                  1
                ),
                _vm._v(" "),
                _vm.surveyWindow.allowClose
                  ? _c(
                      "div",
                      {
                        class: _vm.surveyWindow.cssHeaderCloseButton,
                        on: { click: _vm.doHide },
                      },
                      [
                        _c("sv-svg-icon", {
                          attrs: { iconName: "icon-close_16x16", size: 16 },
                        }),
                      ],
                      1
                    )
                  : _vm._e(),
              ]),
            ]),
            _vm._v(" "),
            _c(
              "div",
              { class: _vm.surveyWindow.cssBody },
              [
                _c(_vm.getSurveyComponentName(), {
                  tag: "component",
                  attrs: { survey: _vm.survey },
                }),
              ],
              1
            ),
          ]),
        ]
      )
    : _vm._e()
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }